module.exports = __webpack_public_path__ + "img/logo_secondary_negative.115811b8.svg";